import { useEffect, useRef } from 'react'

export function useInfiniteScroll(
  loadMore: () => void,
  hasMore: boolean,
  scrollContainerRef?: React.RefObject<HTMLElement | null>,
): React.RefObject<HTMLDivElement | null> {
  const sentinelRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!hasMore) return
    const el = sentinelRef.current
    if (!el) return
    const root = scrollContainerRef?.current ?? null
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) loadMore()
      },
      { threshold: 0, root },
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [loadMore, hasMore, scrollContainerRef])

  return sentinelRef
}
